// Loader.js
import React from "react";
// If using React-Bootstrap Spinner component
// import Spinner from "react-bootstrap/Spinner";

const Loader = () => (
  <div className="d-flex justify-content-center align-items-center vh-30 p-4">
    <div className="d-flex justify-content-center align-items-center vh-30 ">
      <div
        className="spinner-border text-primary"
        style={{ width: "2rem", height: "2rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
);

export default Loader;
